import React from "react";

/**
 * Estructura del contexto que usa la app
 */
const MyContext = React.createContext({
  industry: "",
  updateIndustry: (industry: string) => {},
  channel: "",
  updateChannel: (channel: string) => {},
  message: "",
  updateMessage: (message: string) => {},
  platform: "",
  updatePlatform: (platform: string) => {},
  showResponse: false,
  updateShowResponse: (showResponse: boolean) => {},
  showPlatform: false,
  updateShowPlatform: (showPlatform: boolean) => {},
  openModal: false,
  updateOpenModal: (openModal: boolean) => {},
});

export default MyContext;
